import { InputHTMLAttributes, forwardRef } from 'react';
import { Icon, Input, Label } from './styles';

interface InputFileProps extends InputHTMLAttributes<HTMLInputElement> {
  icon: string;
}

const InputFile = forwardRef<HTMLInputElement, InputFileProps>(({ icon, id = 'file', ...props }, ref) => {
  return (
    <Label htmlFor={id} title={props.title} disabled={props.disabled}>
      <Input id={id} type="file" ref={ref} {...props} />

      <Icon src={icon} />
      {props.title}
    </Label>
  );
});

export { InputFile };
